import React from "react";
import { SharedProposalRenderGateway } from "../components/shareable-proposal/SharedProposalRendererGateway";

export function PublicSharedProposalPage() {
  return <SharedProposalRenderGateway />;
}
